/* eslint-disable prettier/prettier */
import { handleCatchError } from 'utils/CatchHandler';
import { GET_API_ENDPOINTS, POST_API_ENDPOINTS } from './Endpoints';
import { axiosBaseUrlMs } from 'instance/Axios';

// const commonEndPoint = 'api/V2/';
// const handleApiRequest = async (method, endpoint, payload = null) => {
//     try {
//         const response =
//             method === 'GET'
//                 ? await merchantCommonGetRequest(endpoint, payload) // Pass params for GET
//                 : await merchantCommonPost(endpoint, payload); // Pass body for POST

//         return response;
//     } catch (error) {
//         console.error('API Error:', error);
//         return null;
//     }
// };

const latitude = localStorage.getItem('latitude');
const longitude = localStorage.getItem('longitude');
const axiosDMT = axiosBaseUrlMs('/api/dmt');
const axiosAuth = axiosBaseUrlMs('/api/auth');

// const merchantCommonPost = async (apiEndPoint, payload) => {
//     const endPoint = commonEndPoint + apiEndPoint;
//     const token = localStorage.getItem('token');
//     let merchantEmpID;
//     const isEmployee = localStorage.getItem('isEmployee');
//     if (isEmployee === 'true') {
//         merchantEmpID = localStorage.getItem('empId');
//     }
//     const headers = {
//         Authorization: `Bearer ${token}`,
//         'Header-Merchant-Employee': merchantEmpID,
//         'Content-Type': 'application/json',
//         'X-Latitude': latitude,
//         'X-Longitude': longitude
//     };
//     try {
//         const response = await axiosInstanceLive.post(
//             endPoint,
//             payload,

//             {
//                 headers
//             }
//         );
//         return response;
//     } catch (error) {
//         console.log(error);
//         handleCatchError(error);
//         return error;
//     }
// };
const merchantCommonGetRequestForDmt = async (apiEndPoint) => {
    try {
        const authToken = localStorage.getItem('AuthToken');
        const headers = { Authorization: `Bearer ${authToken}`, 'service-type': 'web', 'x-latitude': latitude, 'x-longitude': longitude };
        const response = await axiosDMT.get(apiEndPoint, { headers });

        return response;
    } catch (error) {
        console.error('DMT GET request error:', error);
        // handleCatchError(error);
        throw error;
    }
};

const merchantCommonPostRequestForDmt = async (apiEndPoint, payload) => {
    try {
        const authToken = localStorage.getItem('AuthToken');
        const headers = { Authorization: `Bearer ${authToken}`, 'service-type': 'web', 'x-latitude': latitude, 'x-longitude': longitude };
        const response = await axiosDMT.post(apiEndPoint, payload, { headers });
        return response;
    } catch (error) {
        console.error('DMT POST request error:', error);
        handleCatchError(error);
        throw error;
    }
};

const merchantCommonPostRequestForAuth = async (apiEndPoint, payload) => {
    try {
        // const authToken = localStorage.getItem('AuthToken');
        const authToken =
            'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJiYTEyOTgwNi1hN2E2LTQzYWYtODM2Mi1hMGUwZjBjNjNjODgiLCJlbWFpbCI6InNydXRoeXMyNDBAZ21haWwuY29tIiwidXNlclR5cGUiOiJhZ2dyZWdhdG9yIiwiaWF0IjoxNzcxODIxOTMyLCJleHAiOjE3NzIyNTM5MzJ9.ww6ksmAcikC7VJgsUwWQDOQOQT7ZyW8KyKGsULW43Pc';
        const headers = { Authorization: `Bearer ${authToken}`, 'service-type': 'web', 'x-latitude': latitude, 'x-longitude': longitude };
        const response = await axiosAuth.post(apiEndPoint, payload, { headers });
        return response;
    } catch (error) {
        console.error('DMT POST request error:', error);
        handleCatchError(error);
        throw error;
    }
};

export const fetchCustomerList = async (dmtType, page = 1, limit = 10, agentId, searchText = '') => {
    const endpoint =
        dmtType === 'fino'
            ? GET_API_ENDPOINTS.dmtListCustomersFino
            : dmtType === 'iServeu'
                ? GET_API_ENDPOINTS.dmtListCustomersIserveu
                : dmtType === 'airtel'
                    ? GET_API_ENDPOINTS.dmtListCustomersAirtel
                    : '';
    const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        agentId: agentId?.toString()
    });

    if (searchText?.trim()) {
        queryParams.append('searchText', searchText.trim());
    }

    const fullUrl = `${endpoint}?${queryParams.toString()}`;
    try {
        const response = await merchantCommonGetRequestForDmt(fullUrl);
        return response;
    } catch (error) {
        console.error('Error fetching customer list:', error);
        return null;
    }
};

export const fetchBeneficiaryList = async (agentId, customerId, page = 1, limit = 10, searchText = '') => {
    // const url = `${GET_API_ENDPOINTS.dmtListBeneficiaryFino}?agentId=${agentId}&customerId=${customerId}&page=${page}&limit=${limit}`;
    const queryParams = new URLSearchParams({
        agentId,
        customerId,
        page: page.toString(),
        limit: limit.toString()
    });
    if (searchText?.trim()) {
        queryParams.append('searchText', searchText.trim());
    }

    const url = `${GET_API_ENDPOINTS.dmtListBeneficiaryFino}?${queryParams.toString()}`;

    try {
        const response = await merchantCommonGetRequestForDmt(url);
        return response;
    } catch (error) {
        // console.log(error);
        return error;
    }
};

export const processCustomerEkyc = async (payload) => {
    try {
        const response = await merchantCommonPostRequestForDmt(POST_API_ENDPOINTS.processCustomerEKYC, payload);
        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const ekycOtpVerify = async (payload) => {
    try {
        const response = await merchantCommonPostRequestForDmt(POST_API_ENDPOINTS.ekycOtpVerify, payload);
        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const resentOtp = async (payload) => {
    try {
        const response = await merchantCommonPostRequestForDmt(POST_API_ENDPOINTS.resentOtp, payload);
        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const createBeneficiaryApi = async (payload) => {
    try {
        const response = await merchantCommonPostRequestForDmt(POST_API_ENDPOINTS.createBeneficiary, payload);
        return response;
    } catch (error) {
        return error;
    }
};

export const getCustomerByVendor = async (payload) => {
    try {
        const response = await merchantCommonPostRequestForDmt(GET_API_ENDPOINTS.getCustomerByVendor, payload);
        return response;
    } catch (error) {
        return error;
    }
};

export const getCustomerLimit = async (payload) => {
    try {
        const response = await merchantCommonPostRequestForDmt(POST_API_ENDPOINTS.getCustomerLimit, payload);
        return response;
    } catch (error) {
        return error;
    }
};

export const generateTxnOtp = async (payload) => {
    try {
        const response = await merchantCommonPostRequestForDmt(POST_API_ENDPOINTS.generateTxnOtp, payload);
        return response;
    } catch (error) {
        return error;
    }
};

export const fundTransferApi = async (payload) => {
    try {
        const response = await merchantCommonPostRequestForDmt(POST_API_ENDPOINTS.fundTransfer, payload);
        return response;
    } catch (error) {
        return error;
    }
};
export const getChargesDMTTransferApi = async (payload) => {
    try {
        const response = await merchantCommonPostRequestForDmt(POST_API_ENDPOINTS.getChargesDMTTransfer, payload);
        return response;
    } catch (error) {
        return error;
    }
};
export const deleteBeneficiaryApi = async (payload) => {
    try {
        const response = await merchantCommonPostRequestForDmt(POST_API_ENDPOINTS.deleteBeneficiary, payload);
        return response;
    } catch (error) {
        return error;
    }
};

export const moneyTransferList = async (customerId, page, limit, searchText = '') => {
    const queryParams = new URLSearchParams({
        customerId,
        page: page.toString(),
        limit: limit.toString()
    });
    // const url = `${GET_API_ENDPOINTS.moneyTransferList}?customerId=${customerId}&page=${page}&limit=${limit}`;

    if (searchText?.trim()) {
        queryParams.append('searchText', searchText.trim());
    }
    const url = `${GET_API_ENDPOINTS.moneyTransferList}?${queryParams.toString()}`;

    try {
        const response = await merchantCommonGetRequestForDmt(url);
        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const getTransferReceipt = async (orderId) => {
    const url = `${GET_API_ENDPOINTS.getOrderReceipt}?orderId=${orderId}`;

    try {
        const response = await merchantCommonGetRequestForDmt(url);
        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const editCustomer = async (payload) => {
    try {
        const response = await merchantCommonPostRequestForDmt(POST_API_ENDPOINTS.editCustomer, payload);
        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
};
export const dmt3GenerateToken = async (payload) => {
    try {
        const response = await merchantCommonPostRequestForDmt(POST_API_ENDPOINTS.generate_token, payload);
        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const verifyBeneficiaryPennyDropApi = async (payload) => {
    try {
        const response = await merchantCommonPostRequestForAuth(POST_API_ENDPOINTS.verifyBeneficiaryPennyDrop, payload);
        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const editBeneficiaryApi = async (payload) => {
    try {
        const response = await merchantCommonPostRequestForDmt(POST_API_ENDPOINTS.editBeneficiary, payload);
        return response;
    } catch (error) {
        console.log(error);
        return null;
    }
};
